module.exports = __webpack_public_path__ + "img/map.f0e6f628.png";